import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseToolsUrl + '/svn/api/v1/'

export const getProjects = (params) => {
  return axios.request({
    url: baseUrl + 'project/list/',
    params: params,
    method: 'get'
  })
}

export const getAllUsers = (params) => {
  return axios.request({
    url: baseUrl + 'user/list/',
    params: params,
    method: 'get'
  })
}

export const addProjectMember = (data) => {
  return axios.request({
    url: baseUrl + 'project_user/add/',
    data: data,
    method: 'post'
  })
}

export const deleteProjectMember = (data) => {
  return axios.request({
    url: baseUrl + 'project_user/delete/',
    data: data,
    method: 'delete'
  })
}

export const getProjectUsers = (params) => {
  return axios.request({
    url: baseUrl + 'project_user/list/',
    params: params,
    method: 'get'
  })
}

// 组管理
export const addGroupMember = (data) => {
  return axios.request({
    url: baseUrl + 'group_user/add/',
    data: data,
    method: 'post'
  })
}

export const deleteGroupMember = (data) => {
  return axios.request({
    url: baseUrl + 'group_user/delete/',
    data: data,
    method: 'delete'
  })
}

export const getGroupUsers = (params) => {
  return axios.request({
    url: baseUrl + 'group_user/list/',
    params: params,
    method: 'get'
  })
}

export const getAllProjects = () => {
  return axios.request({
    url: baseUrl + 'project/list/all/',
    method: 'get'
  })
}
